/**
 * Story deletes that still have prompt responses are an expected restriction,
 * not an application fault (#16355 / SLAPFIVE-FRONTEND-A54).
 *
 * PromptResponse.story_id is ON DELETE RESTRICT, so a Story linked to a
 * prompt response cannot be deleted (#10848). The UI explains that and
 * Sentry must not record the expected failure (#16355).
 */
const PROMPT_RESPONSE_STORY_FK = 'PromptResponse_story_id_fkey';

export function isExpectedPromptResponseStoryDeleteError(
  message: string | null | undefined
): boolean {
  return typeof message === 'string' && message.includes(PROMPT_RESPONSE_STORY_FK);
}
